// Visit-service capture (home / site / outreach). Backend:
// clinical_notes.VisitServiceRecord. total_pgk is computed server-side.
import { api } from './client.js'
import { endpoints } from './endpoints.js'
import { unwrapList } from '../utils/format.js'

export async function listVisitServices(params = {}) {
  const { data } = await api.get(endpoints.visitServices, { params })
  return unwrapList(data)
}
export async function createVisitService(payload) {
  const { data } = await api.post(endpoints.visitServices, payload)
  return data
}
